import React from 'react'
import { Link } from 'react-router-dom'
const ChannelCard = ({ channelDetail }) => {
  return (
    <div>
      <div className='cursor-pointer w-[325px] h-[182px]'>
      <Link className='grid place-items-center' to={`/channel/${channelDetail?.id?.channelId}`}>
        <img className='w-[150px] h-[150px] rounded-[50%] mb-2' src={channelDetail?.snippet?.thumbnails?.high?.url} alt="Thumbnail" />
        <p className='text-[1rem] font-semibold px-2 pb-2'>{channelDetail?.snippet?.title}</p>
        {channelDetail?.statistics?.subscriberCount && 
        <p className='text-[1rem] font-semibold relative bottom-2'>{parseInt(channelDetail?.statistics?.subscriberCount
          ).toLocaleString()} subscribers</p>
        }
      </Link>
      </div>
    </div>
  )
}

export default ChannelCard